import { DetailInvoice } from "pages/Sales/Transaction/Invoice/types"
import { createContext } from "react"

export const DataContext = createContext<Pick<DetailInvoice["datainvoice"], "sales_order_id" | "invoice_id">>({
    sales_order_id: 0,
    invoice_id: 0
})